<template>
	<div>
		<div class="title-container">
			<div class="title">
				Create Module
				<div class="subtitle"><span class="fa fa-globe"></span>{{ account.name }}</div>
			</div>
			<div class="buttons">
				<router-link :to="{ name: 'super-account-modules-page', params: $route.params }" exact class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<module-form v-model="form" :is-saving="formSaving" :parent-modules="info.nonNestedModules" @submitted="onSubmit"></module-form>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import ModuleForm from './components/ModuleFormComponent';

export default {

	mixins: [FormMixin],

	name: 'AccountsModulesCreatePage',

	async asyncData({ app, route, store }) {
		const { data } = await app.$api.get(`/super/accounts/${ route.params.accountId }/modules/create`);

		return {
			info: data.data,
			account: store.state.auth.accountsById[ route.params.accountId ],
		};
	},

	data() {
		return {
			form: {
				module_type: 'Basic',
				can_add: true,
				can_edit: true,
				can_delete: true,
				can_view: true,
				fields: [{ id: 'new1', type: 'string', config: {} }, { id: 'new2', config: {} }],
				searchable: 1,
			}
		};
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.post(`/super/accounts/${ this.account.id }/modules`, this.form);

				this.$store.dispatch('addToast', 'Row Created');
				this.$router.back();
			}, (e) => {
				this.$store.dispatch('errorToast', 'Unable to save module: ' + e.message);
			});
		},

	},

	components: {
		ModuleForm,
	},

};

</script>
